module.exports = __webpack_public_path__ + "img/BS.86ea8710.png";